import { Fragment, useEffect, useRef } from 'react';

import { Kbd } from '../ui.tsx';
import * as wording from '../wording.ts';
import { BOARD_SHORTCUTS } from './keys.ts';

/**
 * Every key the board answers to (`?`, US-027), on the native `<dialog>` like
 * `ConfirmDialog`: Esc, the focus trap and the inert board come with it, and
 * an open dialog is what keeps the board's keys quiet.
 */
export function ShortcutsDialog({ open, onClose }: { readonly open: boolean; readonly onClose: () => void }) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = ref.current;
    if (dialog === null) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog className="dialog" ref={ref} aria-labelledby="board-shortcuts-title" onClose={onClose}>
      <h2 className="dialog__title" id="board-shortcuts-title">
        {wording.BOARD_SHORTCUTS}
      </h2>
      <div className="dialog__body">
        <dl className="board-shortcuts">
          {BOARD_SHORTCUTS.map((shortcut) => (
            <Fragment key={shortcut.keys.join(' ')}>
              <dt>
                {shortcut.keys.map((key, index) => (
                  <Fragment key={key}>
                    {index > 0 && (shortcut.keys[0] === 'g' ? ' then ' : ' / ')}
                    <Kbd>{key}</Kbd>
                  </Fragment>
                ))}
              </dt>
              <dd>{shortcut.does}</dd>
            </Fragment>
          ))}
        </dl>
      </div>
      <div className="dialog__actions">
        <button type="button" className="button" onClick={onClose} autoFocus>
          {wording.BOARD_SHORTCUTS_CLOSE}
        </button>
      </div>
    </dialog>
  );
}
